import { render, staticRenderFns } from "./tree.vue?vue&type=template&id=203a2165&scoped=true&"
import script from "./tree.vue?vue&type=script&lang=babel&"
export * from "./tree.vue?vue&type=script&lang=babel&"
import style0 from "./tree.vue?vue&type=style&index=0&id=203a2165&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "203a2165",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTreeview } from 'vuetify/lib/components/VTreeview';
installComponents(component, {VTreeview})
